export default __webpack_public_path__ + "c67b5ce9bd44cd92fd113d983bbcd055.webp";